"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiAutocomplete = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var colors_1 = require("../../generated/colors");
var general_1 = require("../../generated/icons/general");
var global_1 = require("../../global");
exports.MuiAutocomplete = {
    defaultProps: {
        disablePortal: true,
        popupIcon: (0, jsx_runtime_1.jsx)(general_1.Search, { width: "24px", height: "24px" }, void 0),
        noOptionsText: "Ingen resultater",
    },
    styleOverrides: {
        root: {
            "&.MuiAutocomplete-hasPopupIcon .MuiAutocomplete-inputRoot .MuiAutocomplete-endAdornment": {
                position: "absolute",
                right: "12px",
                top: "calc(50% - 15px)",
            },
            "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiFilledInput-root": {
                paddingRight: "32px",
            },
        },
        input: {
            "&::placeholder": {
                textAlign: "center",
                color: colors_1.colors.Grey1,
            },
        },
        inputRoot: {
            paddingTop: 0,
            paddingLeft: global_1.spacing[4],
            paddingRight: global_1.spacing[4],
        },
        clearIndicator: {
            color: colors_1.colors.Text,
            "&:hover": {
                backgroundColor: "transparent",
            },
            "+ .MuiAutocomplete-popupIndicator": {
                display: "none",
            },
        },
        popupIndicator: {
            color: colors_1.colors.Text,
            transform: "rotate(0)",
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
        listbox: {
            "& .MuiAutocomplete-option": {
                paddingLeft: global_1.spacing[4],
                fontSize: "1rem",
                fontWeight: global_1.fontWeight.bold,
                height: "2rem",
                minHeight: "2rem",
                lineHeight: "1.5rem",
                margin: global_1.spacing[0],
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                "&.Mui-focused": {
                    backgroundColor: colors_1.colors.Mint25,
                },
                "&[aria-selected=true]": {
                    backgroundColor: colors_1.colors.Mint50,
                    "&.Mui-focused": {
                        backgroundColor: colors_1.colors.Mint25,
                    },
                },
            },
        },
        /**
         * The paper property will hold the popper with the listbox.
         * When using freeSolo to avoid showing the no options text,
         * then don't apply the styling, as the shadow will be visible
         * otherwise
         */
        paper: {
            "&:not(:empty)": {
                borderRadius: "4px",
                boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.3),\n                  0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
            },
        },
        noOptions: {
            paddingLeft: global_1.spacing[4],
            fontSize: "1rem",
        },
    },
};
//# sourceMappingURL=autocomplete.js.map